<template>
    <section class="main">
        <slot/>
    </section>
</template>

<script>
    export default {
        name: 'Main'
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .main {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: 50vh;
    }
    
    @media all and (max-width: 1024px) {
        .main {
            flex-wrap: wrap;
        }
    }
</style>